module.exports = __webpack_public_path__ + "img/Avatar-78.ed95fe4c.svg";